import { featureFlags } from '@core/consts';
import { merchantCategoryRoutes, Route } from '@navigation';
import { mc, StyleProps } from '@styles';
import { TestIdProps } from '@utils';
import { sortBy } from 'lodash';
import React, { FC, useState } from 'react';

import ChevronDown from './assets/chevron-down.inline.svg';
import ChevronUp from './assets/chevron-up.inline.svg';

interface Props extends StyleProps, TestIdProps {
  onLinkClick?: () => void;
}

export const FooterExpanded: FC<Props> = ({ className, style, testId, onLinkClick }) => {
  const [extended, setExtended] = useState<boolean>(false);

  const renderLinks = (links: Route[]) => {
    return links.map((r, idx) => (
      <li
        key={r.label}
        className={`hover:text-accent-orange text-ocean-blue font-medium text-sm ${idx === links.length - 1 ? '' : 'mb-4'}`}
      >
        <a className="leading-5" href={r.url} onClick={onLinkClick}>
          {r.label}
        </a>
      </li>
    ));
  };

  const renderCategory = (title: string, category: Route) => {
    const links: Route[] = [category];
    if (category.sub) links.push(...sortBy(Object.values(category.sub), 'index'));
    return (
      <>
        <li className={`text-ocean-blue font-bold text-sm mb-4`}>
          <span className="block leading-5">{title}</span>
        </li>
        {renderLinks(links)}
      </>
    );
  };

  return (
    <div data-testid={testId} className={mc('py-5', className)} style={style}>
      <a
        onClick={() => setExtended(!extended)}
        role="button"
        className="cursor-pointer text-sm font-medium leading-5 flex flex-row items-center text-ocean-blue hover:text-accent-orange fill-ocean-blue hover:fill-accent-orange"
      >
        <span className="block mr-2">Popular Topics</span> {extended ? <ChevronUp /> : <ChevronDown />}
      </a>

      {extended && (
        <div className="mt-4 flex flex-col md:flex-row justify-between">
          <ul className="mt-6 md:mt-0">{renderCategory('Category & Support', merchantCategoryRoutes.careSupport)}</ul>
          {featureFlags.financeMegaCategoryEnabled && (
            <ul className="mt-6 md:mt-0">{renderCategory('Finance', merchantCategoryRoutes.finance)}</ul>
          )}
          <ul className="mt-6 md:mt-0">{renderCategory('Health', merchantCategoryRoutes.health)}</ul>
          <ul className="mt-6 md:mt-0">{renderCategory('Housing', merchantCategoryRoutes.housing)}</ul>
          <ul className="mt-6 md:mt-0">{renderCategory('Legal', merchantCategoryRoutes.legal)}</ul>
        </div>
      )}
    </div>
  );
};

export default FooterExpanded;
